(() => {

  const STORAGE_KEY = 'cartCountdownEnd';
  const COUNTDOWN_TIME = 10 * 60 * 1000;

  let interval = null;


  function getTimerElement() {
    return document.querySelector('.announcement-cart__countdown');
  }


  function stopTimer() {
    if (interval) {
      clearInterval(interval);
      interval = null;
    }
  }


  function resetTimer() {
    localStorage.removeItem(STORAGE_KEY);

    const timer = getTimerElement();

    if (timer) {
      timer.textContent = '10:00';
    }

    stopTimer();
  }


  function updateTimer() {

    const timer = getTimerElement();

    if (!timer) return;


    const endTime = Number(
      localStorage.getItem(STORAGE_KEY)
    );


    if (!endTime) {
      timer.textContent = '10:00';
      return;
    }


    const remaining = endTime - Date.now();


    if (remaining <= 0) {

      timer.textContent = '00:00';

      stopTimer();

      return;
    }


    const minutes = Math.floor(
      remaining / 60000
    );

    const seconds = Math.floor(
      (remaining % 60000) / 1000
    );


    timer.textContent =
      String(minutes).padStart(2,'0')
      + ':' +
      String(seconds).padStart(2,'0');

  }


  function startTimer() {

    // Evitar varios intervalos
    stopTimer();


    updateTimer();


    interval = setInterval(() => {
      updateTimer();
    },1000);

  }


  async function checkCart() {

    try {

      const response = await fetch('/cart.js');

      const cart = await response.json();


      /*
        Si hay productos y no existe contador,
        iniciar los 10 minutos
      */

      if (cart.item_count > 0) {

        if (!localStorage.getItem(STORAGE_KEY)) {

          localStorage.setItem(
            STORAGE_KEY,
            Date.now() + COUNTDOWN_TIME
          );

        }


        startTimer();


      } else {

        resetTimer();

      }


    } catch(error){

      console.error(
        'Cart countdown error:',
        error
      );

    }

  }



  /*
    Primera carga
  */
  document.addEventListener(
    'DOMContentLoaded',
    () => {

      checkCart();

    }
  );



  /*
    Cuando Craft actualiza el drawer
  */
  document.addEventListener(
    'shopify:section:load',
    () => {

      checkCart();

    }
  );



  /*
    Evento de Craft/Dawn cuando cambia el carrito
  */
  document.addEventListener(
    'cart:updated',
    () => {

      checkCart();

    }
  );



  /*
    Detectar cambios de carrito publicados
    por PUB_SUB_EVENTS de Shopify
  */
  if (typeof subscribe !== 'undefined'
      && typeof PUB_SUB_EVENTS !== 'undefined') {


    subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      () => {

        checkCart();

      }
    );

  }


})();